import { getStore } from "../store/store";
import type FocusedViewFilter from "owa-service/lib/contract/FocusedViewFilter";
import type InboxViewType from "owa-service/lib/contract/InboxViewType";
import { addDatapointConfig } from "owa-analytics-actions";
import type { ActionSource } from "owa-mail-store";
import { action, orchestrator, mutatorAction } from "satcheljs";
import { updateAccountScopeUserSettingsAndService } from "owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService";
import type { MailboxInfo } from "owa-client-types";

/**
 * Update last visit timestamps for selected view and reset rollup data
 */
export interface UpdateWatermarksAndResetRollupActionMessage {
    focusedViewFilterToSelect: FocusedViewFilter;
    mailboxInfo: MailboxInfo;
}
const updateWatermarksAndResetRollup: (focusedViewFilterToSelect: FocusedViewFilter, actionSource: ActionSource, mailboxInfo: MailboxInfo) => UpdateWatermarksAndResetRollupActionMessage = action("updateWatermarksAndResetRollup", (focusedViewFilterToSelect: FocusedViewFilter, actionSource: ActionSource, mailboxInfo: MailboxInfo): UpdateWatermarksAndResetRollupActionMessage => addDatapointConfig("TnS_ResetFocusedOtherRollup", mailboxInfo, {
    customData: [actionSource, focusedViewFilterToSelect],
    options: { isScorecardEvent: true },
}, { focusedViewFilterToSelect, mailboxInfo }));

/**
 * Reset rollup data in store
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const resetRollupStore: (mailboxInfo: MailboxInfo) => void = mutatorAction("resetRollupStore", (mailboxInfo: MailboxInfo): void => {
    const store = getStore(mailboxInfo);
    
    store.uniqueSenders = undefined;
    store.unseenCountToDisplay = undefined;
    store.viewType = 0;
});

/**
 * Update folder view watermark for focused/other folders
 */
orchestrator(updateWatermarksAndResetRollup, actionMessage => {
    const currentTime = new Date(Date.now()).toUTCString();
    
    updateAccountScopeUserSettingsAndService(actionMessage.mailboxInfo, {
        ViewStateConfiguration: {
            FocusedViewWatermark: currentTime,
            ClutterViewWatermark: currentTime,
        },
    });
    
    resetRollupStore(actionMessage.mailboxInfo);
});

export default updateWatermarksAndResetRollup;
